import { lazy, Suspense } from 'react';

function onDemand(load) {
  const Component = lazy(load);
  return function LazyAuthModal({ isOpen, ...props }) {
    if (!isOpen) return null;
    return (
      <Suspense fallback={<div className="modal-overlay"><p role="status" className="modal-container">Opening form…</p></div>}>
        <Component {...props} isOpen />
      </Suspense>
    );
  };
}

export const LoginModal = onDemand(() => import('./LoginModal'));
export const VerifyOTPModal = onDemand(() => import('./VerifyOTPmodal'));
export const ForgotPasswordModal = onDemand(() => import('./ForgotPasswordModal'));
export const ResetPasswordModal = onDemand(() => import('./ResetPasswordModal'));
